module.exports = __webpack_public_path__ + "static/media/Miles Franklyn.75aa3dce.jpeg";